/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Remove_Marker_LabelInputs */

const en_markers_remove_marker_label = /** @type {(inputs: Markers_Remove_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove selected marker`)
};

const fr_markers_remove_marker_label = /** @type {(inputs: Markers_Remove_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer le marqueur selectionne`)
};

const de_markers_remove_marker_label = /** @type {(inputs: Markers_Remove_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählte Markierung entfernen`)
};

const it_markers_remove_marker_label = /** @type {(inputs: Markers_Remove_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi il marcatore selezionato`)
};

const ru_markers_remove_marker_label = /** @type {(inputs: Markers_Remove_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить выбранный маркер`)
};

const es_markers_remove_marker_label = /** @type {(inputs: Markers_Remove_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar el marcador seleccionado`)
};

const zh_cn2_markers_remove_marker_label = /** @type {(inputs: Markers_Remove_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`移除选定标记`)
};

const ja_markers_remove_marker_label = /** @type {(inputs: Markers_Remove_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したマーカーを削除`)
};

const hi_markers_remove_marker_label = /** @type {(inputs: Markers_Remove_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित मार्कर को हटाएँ`)
};

const pt_pt2_markers_remove_marker_label = /** @type {(inputs: Markers_Remove_Marker_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover marcador selecionado`)
};

/**
* | output |
* | --- |
* | "Remove selected marker" |
*
* @param {Markers_Remove_Marker_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_remove_marker_label = /** @type {((inputs?: Markers_Remove_Marker_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Remove_Marker_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_remove_marker_label(inputs)
	if (locale === "de") return de_markers_remove_marker_label(inputs)
	if (locale === "it") return it_markers_remove_marker_label(inputs)
	if (locale === "ru") return ru_markers_remove_marker_label(inputs)
	if (locale === "es") return es_markers_remove_marker_label(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_remove_marker_label(inputs)
	if (locale === "ja") return ja_markers_remove_marker_label(inputs)
	if (locale === "hi") return hi_markers_remove_marker_label(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_remove_marker_label(inputs)
	return en_markers_remove_marker_label(inputs)
});